var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99963 2.39722L3.27362 6.15134L5.63374 7.46869L12.3599 3.71458L9.99963 2.39722ZM19.021 5.57007L19.1597 5.32162L10.4731 0.473123C10.1793 0.309089 9.81997 0.309089 9.52609 0.473123L0.839528 5.32162L0.839507 5.32163C0.543486 5.48687 0.349609 5.80023 0.349609 6.1516V15.8486C0.349609 16.2 0.543482 16.5133 0.839523 16.6786L0.839529 16.6786L9.5261 21.5271C9.81997 21.6911 10.1793 21.6911 10.4731 21.5271L19.1597 16.6786L19.1597 16.6786C19.4557 16.5133 19.6496 16.2 19.6496 15.8486V6.1516C19.6496 5.80024 19.4557 5.48686 19.1597 5.32162L19.021 5.57007ZM14.3204 4.80886L7.59443 8.56297L9.99966 9.90547L16.7256 6.15136L14.3204 4.80886ZM9.03636 11.5564L2.27677 7.78344V15.2917L9.03636 19.0646V11.5564ZM10.963 19.0646L17.7227 15.2917V7.78351L10.963 11.5564V19.0646Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.16d381f7efc90a7bbaf43f77fd30b9db.svg";
export { ForwardRef as ReactComponent };